import { CreatorbaseCurrencyContext } from './CreatorbaseCurrencyContext';
import useNonNullContext from '../../Hooks/useNonNullContext';

export function useCreatorbaseCurrencies() {
    const context = useNonNullContext(CreatorbaseCurrencyContext);
    return context;
}
